import React, { useCallback, useState } from "react";
import { Button } from "components/bootstrap";
import CollectionModal from "collections/components/CollectionModal";
import useCollectionMutation from "collections/hooks/useCollectionMutation";
const UpdateCollectionButton = ({
  bsSize = "md",
  bsStyle = "default",
  buttonText = "Update collection",
  editCollection
}) => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const toggleUpdateModal = useCallback(() => setShowUpdateModal((cur) => !cur), []);
  const { updateCollection } = useCollectionMutation();
  const onUpdate = (values) => updateCollection({
    title: values.title,
    description: values.description,
    id: editCollection.id
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsSize, bsStyle, onClick: toggleUpdateModal }, buttonText), showUpdateModal && /* @__PURE__ */ React.createElement(
    CollectionModal,
    {
      title: "Update collection",
      submitButtonText: "Update collection",
      submitLoadingText: "Updating collection...",
      onSubmit: onUpdate,
      onClose: toggleUpdateModal,
      initialCollection: editCollection
    }
  ));
};
export default UpdateCollectionButton;
